import { isFunction } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';

export default ({ path, file }) => {
  const [component, setComponent] =
    useState<React.CElement<{}, React.Component<{}, any, any>>>();

  const load = async (file) => {
    const promise = isFunction(file) ? file() : file;
    const response = await promise;
    const component = React.createElement(response.default);
    setComponent(component);
  };

  useEffect(() => {
    isFunction(file) || file instanceof Promise
      ? load(file)
      : setComponent(file);
  }, []);

  return <Route path={path}>{component}</Route>;
};
